import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-knowLedgeBase",
  "use": "icon-knowLedgeBase-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-knowLedgeBase\"><defs><style type=\"text/css\"></style></defs><path d=\"M204.8 0C91.022222 0 0 85.333333 0 193.422222v642.844445C0 938.666667 91.022222 1024 204.8 1024H967.111111V0H204.8z m625.777778 893.155556h-625.777778c-39.822222 0-68.266667-28.444444-68.266667-62.577778 0-34.133333 28.444444-62.577778 68.266667-62.577778h620.088889v125.155556z\" p-id=\"763\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol